import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { RegistrationService } from '../services/registration.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  submitText = 'Register';
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private registrationService: RegistrationService,
  ) {}

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      organisation: ['', Validators.required],
      mobilePhone: ['', [Validators.required, Validators.pattern(/^(?=(?:[^0-9]*[0-9]){7})[0-9 +-]+$/)]],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  onSubmit() {
    if (this.registerForm.invalid) return;
    this.submitText = 'Please Wait ...';
    this.registrationService.register(this.registerForm.value).subscribe(
      (response) => {
        Swal.fire({
          icon: 'success',
          text: response?.message || 'Registration submitted.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        }).then(() => {
          this.router.navigate(['/login']);
        });
      },
      (error) => {
        console.error(error);
        this.submitText = 'Register';
        Swal.fire({
          icon: 'error',
          text: 'Registration failed. Please try again.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      },
    );
  }
}
